

































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import SceneCard from "@/components/SceneCard.vue";
import sceneFragment from "@/fragments/scene";
import actorFragment from "@/fragments/actor";
import studioFragment from "@/fragments/studio";
import LabelSelector from "@/components/LabelSelector.vue";
import { contextModule } from "@/store/context";
import InfiniteLoading from "vue-infinite-loading";
import ActorSelector from "@/components/ActorSelector.vue";
import SceneUploader from "@/components/SceneUploader.vue";
import IScene from "@/types/scene";
import IActor from "@/types/actor";
import ILabel from "@/types/label";
import moment from "moment";
import DrawerMixin from "@/mixins/drawer";
import { mixins } from "vue-class-component";
import { sceneModule } from "@/store/scene";

@Component({
  components: {
    SceneCard,
    LabelSelector,
    InfiniteLoading,
    ActorSelector,
    SceneUploader,
  },
})
export default class SceneList extends mixins(DrawerMixin) {
  get showSidenav() {
    return contextModule.showSidenav;
  }

  scenes = [] as IScene[];

  rerollSeed() {
    const seed = Math.random().toString(36);
    localStorage.setItem("pm_seed", seed);
    if (this.sortBy === "$shuffle") this.loadPage(this.page);
    return seed;
  }

  fetchLoader = false;
  fetchError = false;
  fetchingRandom = false;

  selectedActors = (() => {
    const fromLocalStorage = localStorage.getItem("pm_sceneActors");
    if (fromLocalStorage) return JSON.parse(fromLocalStorage);
    return [];
  })() as IActor[];

  get selectedActorIds() {
    return this.selectedActors.map((ac) => ac._id);
  }

  allLabels = [] as ILabel[];

  tryReadLabelsFromLocalStorage(key: string) {
    return (localStorage.getItem(key) || "").split(",").filter(Boolean) as string[];
  }

  selectedLabels = {
    include: this.tryReadLabelsFromLocalStorage("pm_sceneInclude"),
    exclude: this.tryReadLabelsFromLocalStorage("pm_sceneExclude"),
  };

  onSelectedLabelsChange(val: any) {
    localStorage.setItem("pm_sceneInclude", val.include.join(","));
    localStorage.setItem("pm_sceneExclude", val.exclude.join(","));
    this.refreshed = false;
  }

  validCreation = false;
  createSceneDialog = false;
  createSceneName = "";
  createSceneActors = [] as IActor[];
  createSelectedLabels = [] as number[];
  labelSelectorDialog = false;
  addSceneLoader = false;

  sceneNameRules = [(v) => (!!v && !!v.length) || "Invalid scene name"];

  query = localStorage.getItem("pm_sceneQuery") || "";

  set page(page: number) {
    sceneModule.setPage(page);
  }

  get page() {
    return sceneModule.page;
  }

  get numResults() {
    return sceneModule.numResults;
  }

  get numPages() {
    return sceneModule.numPages;
  }

  useDuration = (() => {
    const fromStorage = localStorage.getItem("pm_useDuration");
    if (fromStorage) {
      return fromStorage === "true";
    }
    return false;
  })();
  durationMax = parseInt(localStorage.getItem("pm_durationFilterMax") || "180") || 180;
  durationRange = [
    parseInt(localStorage.getItem("pm_durationMin") || "0") || 0,
    parseInt(localStorage.getItem("pm_durationMax") || this.durationMax.toString()) ||
      this.durationMax,
  ];

  sortDir = localStorage.getItem("pm_sceneSortDir") || "desc";
  sortDirItems = [
    {
      text: "Ascending",
      value: "asc",
    },
    {
      text: "Descending",
      value: "desc",
    },
  ];

  sortBy = localStorage.getItem("pm_sceneSortBy") || "relevance";
  sortByItems = [
    {
      text: "Relevance",
      value: "relevance",
    },
    {
      text: "A-Z",
      value: "name",
    },
    {
      text: "Added to collection",
      value: "addedOn",
    },
    {
      text: "Rating",
      value: "rating",
    },
    {
      text: "Views",
      value: "numViews",
    },
    {
      text: "Duration",
      value: "duration",
    },
    {
      text: "Resolution",
      value: "resolution",
    },
    {
      text: "Size",
      value: "size",
    },
    {
      text: "Release date",
      value: "releaseDate",
    },
    {
      text: "Bookmarked",
      value: "bookmark",
    },
    {
      text: "Random",
      value: "$shuffle",
    },
  ];

  favoritesOnly = localStorage.getItem("pm_sceneFavorite") == "true";
  bookmarksOnly = localStorage.getItem("pm_sceneBookmark") == "true";
  ratingFilter = parseInt(localStorage.getItem("pm_sceneRating") || "0");

  uploadDialog = false;
  isUploadingScene = false;

  selectedScenes = [] as string[];
  deleteSelectedScenesDialog = false;

  labelClasses(label: ILabel) {
    if (this.selectedLabels.include.includes(label._id)) return "font-weight-bold primary--text";
    else if (this.selectedLabels.exclude.includes(label._id)) return "font-weight-bold error--text";
    return "";
  }

  get showCardLabels() {
    return contextModule.showCardLabels;
  }

  selectScene(id: string) {
    if (this.selectedScenes.includes(id))
      this.selectedScenes = this.selectedScenes.filter((i) => i != id);
    else this.selectedScenes.push(id);
  }

  deleteSelection() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeScenes(ids: $ids)
        }
      `,
      variables: {
        ids: this.selectedScenes,
      },
    })
      .then((res) => {
        for (const id of this.selectedScenes) {
          this.scenes = this.scenes.filter((scene) => scene._id != id);
        }
        this.selectedScenes = [];
        this.deleteSelectedScenesDialog = false;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }

  openUploadDialog() {
    this.uploadDialog = true;
  }

  labelIDs(indices: number[]) {
    return indices.map((i) => this.allLabels[i]).map((l) => l._id);
  }

  labelNames(indices: number[]) {
    return indices.map((i) => this.allLabels[i].name);
  }

  openLabelSelectorDialog() {
    if (!this.allLabels.length) {
      ApolloClient.query({
        query: gql`
          {
            getLabels {
              _id
              name
              aliases
            }
          }
        `,
      })
        .then((res) => {
          this.allLabels = res.data.getLabels;
          this.labelSelectorDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.labelSelectorDialog = true;
    }
  }

  addScene() {
    this.addSceneLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($name: String!, $labels: [String!], $actors: [String!]) {
          addScene(name: $name, labels: $labels, actors: $actors) {
            ...SceneFragment
            actors {
              ...ActorFragment
            }
            studio {
              ...StudioFragment
            }
          }
        }
        ${sceneFragment}
        ${actorFragment}
        ${studioFragment}
      `,
      variables: {
        name: this.createSceneName,
        actors: this.createSceneActors.map((a) => a._id),
        labels: this.labelIDs(this.createSelectedLabels),
      },
    })
      .then((res) => {
        this.refreshPage();
        this.createSceneDialog = false;
        this.createSceneName = "";
        this.createSceneActors = [];
        this.createSelectedLabels = [];
      })
      .catch(() => {})
      .finally(() => {
        this.addSceneLoader = false;
      });
  }

  openCreateDialog() {
    this.createSceneDialog = true;
  }

  sceneLabels(scene: any) {
    return scene.labels.map((l) => l.name).sort();
  }

  sceneActorNames(scene: any) {
    return scene.actors.map((a) => a.name).join(", ");
  }

  sceneThumbnail(scene: any) {
    if (scene.thumbnail)
      return `${serverBase}/media/image/${scene.thumbnail._id}?password=${localStorage.getItem(
        "password"
      )}`;
    return "";
  }

  refreshed = true;

  resetPagination() {
    sceneModule.resetPagination();
    this.refreshed = true;
    this.loadPage(this.page).catch(() => {
      this.refreshed = false;
    });
  }

  @Watch("useDuration")
  onUseDurationChange(newVal: boolean) {
    localStorage.setItem("pm_useDuration", "" + newVal);
    this.refreshed = false;
  }

  @Watch("ratingFilter")
  onRatingChange(newVal: number) {
    localStorage.setItem("pm_sceneRating", newVal.toString());
    this.refreshed = false;
  }

  @Watch("favoritesOnly")
  onFavoriteChange(newVal: boolean) {
    localStorage.setItem("pm_sceneFavorite", "" + newVal);
    this.refreshed = false;
  }

  @Watch("bookmarksOnly")
  onBookmarkChange(newVal: boolean) {
    localStorage.setItem("pm_sceneBookmark", "" + newVal);
    this.refreshed = false;
  }

  @Watch("sortDir")
  onSortDirChange(newVal: string) {
    localStorage.setItem("pm_sceneSortDir", newVal);
    this.refreshed = false;
  }

  @Watch("sortBy")
  onSortChange(newVal: string) {
    localStorage.setItem("pm_sceneSortBy", newVal);
    this.refreshed = false;
  }

  @Watch("selectedLabels")
  onLabelChange() {
    this.refreshed = false;
  }

  @Watch("selectedActorIds", { deep: true })
  onSelectedActorsChange(newVal: string[]) {
    localStorage.setItem("pm_sceneActors", JSON.stringify(this.selectedActors));
    this.refreshed = false;
  }

  @Watch("durationRange")
  onDurationRangeChange(newVal: number) {
    localStorage.setItem("pm_durationMin", (this.durationRange[0] || "").toString());
    localStorage.setItem("pm_durationMax", (this.durationRange[1] || "").toString());
    this.refreshed = false;
  }

  @Watch("query")
  onQueryChange(newVal: string | null) {
    localStorage.setItem("pm_sceneQuery", newVal || "");
    this.refreshed = false;
  }

  getRandom() {
    this.fetchingRandom = true;
    this.fetchPage(1, 1, true, Math.random().toString())
      .then((result) => {
        // @ts-ignore
        this.$router.push(`/scene/${result.items[0]._id}`);
      })
      .catch((err) => {
        this.fetchingRandom = false;
      });
  }

  async fetchPage(page: number, take = 24, random?: boolean, seed?: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: SceneSearchQuery!, $seed: String) {
            getScenes(query: $query, seed: $seed) {
              items {
                ...SceneFragment
                actors {
                  ...ActorFragment
                }
                studio {
                  ...StudioFragment
                }
              }
              numItems
              numPages
            }
          }
          ${sceneFragment}
          ${actorFragment}
          ${studioFragment}
        `,
        variables: {
          query: {
            query: this.query || "",
            take,
            page: page - 1,
            actors: this.selectedActorIds,
            include: this.selectedLabels.include,
            exclude: this.selectedLabels.exclude,
            sortDir: this.sortDir,
            sortBy: random ? "$shuffle" : this.sortBy,
            favorite: this.favoritesOnly,
            bookmark: this.bookmarksOnly,
            rating: this.ratingFilter,
            durationMin:
              this.useDuration && this.durationRange[0] !== this.durationMax
                ? this.durationRange[0] * 60
                : null,
            durationMax:
              this.useDuration && this.durationRange[1] !== this.durationMax
                ? this.durationRange[1] * 60
                : null,
          },
          seed: seed || localStorage.getItem("pm_seed") || "default",
        },
      });

      return result.data.getScenes;
    } catch (err) {
      throw err;
    }
  }

  loadPage(page: number) {
    this.fetchLoader = true;
    this.selectedScenes = [];

    return this.fetchPage(page)
      .then((result) => {
        this.fetchError = false;
        sceneModule.setPagination({
          numResults: result.numItems,
          numPages: result.numPages,
        });
        this.scenes = result.items;
      })
      .catch((err) => {
        console.error(err);
        this.fetchError = true;
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  refreshPage() {
    this.loadPage(sceneModule.page);
  }

  mounted() {
    if (!this.scenes.length) this.refreshPage();
  }

  beforeMount() {
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
          }
        }
      `,
    })
      .then((res) => {
        this.allLabels = res.data.getLabels;
        if (!this.allLabels.length) {
          this.selectedLabels.include = [];
          this.selectedLabels.exclude = [];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
